import stringHelper from "@/API/helpers/string";

function buildAccountRelationships(account) {
  return {
    account: {
      type: "accounts",
      id: account.id
    }
  };
}

function buildAccountAttributes(account) {
  return {
    time_zone: "Brasilia",
    email: account.email.toLowerCase(),
    first_name: stringHelper.capitalize(account.first_name),
    last_name: stringHelper.capitalize(account.last_name),
    password: account.password,
    password_confirmation: account.password_confirmation
  };
}

function buildProfileAttributes(profile) {
  return {
    city_name: stringHelper.capitalize(profile.city_name),
    state_name: profile.state_name.toUpperCase(),
    profile_picture: profile.profile_picture,
    birthdate: profile.birthdate
  };
}

function buildPhonesAttributes(phones) {
  return [phones];
}

function buildAccountableRelationships(payload) {
  return {
    account: {
      attributes: buildAccountAttributes(payload.account)
    },
    profile: {
      attributes: buildProfileAttributes(payload.profile)
    },
    phones: {
      attributes: buildPhonesAttributes(payload.phones)
    }
  };
}

function emailVerificationRequestBody(payload) {
  return {
    data: {
      id: payload.account.id,
      type: "accounts"
    }
  };
}

function buildAccountableToAccount(accountable) {
  let specificByType = {
    legals: { cnpj: accountable.cnpj },
    physicals: { cpf: accountable.cpf },
    professionals: {
      mei: accountable.mei,
      cpf: accountable.cpf,
      completed_orders_count: accountable.completed_orders_count,
      rating: accountable.rating
    }
  }[accountable.type];

  return {
    id: accountable.id,
    status: accountable.status,
    type: accountable.type,
    ...specificByType
  };
}

function buildProfileFromAccountable(accountable) {
  return {
    bio: accountable.account.profile.bio,
    birthdate: accountable.account.profile.birthdate,
    city_name: accountable.account.profile.city_name,
    id: accountable.account.profile.id,
    profile_picture: accountable.account.profile.profile_picture,
    rating: accountable.account.profile.rating,
    state_name: accountable.account.profile.state_name,
    type: "profiles"
  };
}

function parseAccountableToAccount(accountable) {
  return {
    accountable: buildAccountableToAccount(accountable),
    accountable_type: accountable.account.accountable_type,
    created_at: accountable.account.created_at,
    email: accountable.account.email,
    first_name: accountable.account.first_name,
    id: accountable.account.id,
    language: accountable.account.language,
    last_name: accountable.account.last_name,
    occupation: accountable.account.occupation,
    profile: buildProfileFromAccountable(accountable),
    status: accountable.account.status,
    time_zone: accountable.account.time_zone,
    type: "accounts"
  };
}

export default {
  buildAccountableRelationships,
  emailVerificationRequestBody,
  buildAccountRelationships,
  parseAccountableToAccount
};



// WEBPACK FOOTER //
// ./src/API/helpers/accountables.js